import WebsocketReconnect from './WebsocketReconnect'

const TestComponent = {
    WebsocketReconnect,
}

export default TestComponent
